/**
 * Tool confirmation: pause a campaign.
 *
 * Input shape (from server): { campaignId: string, campaignName?: string, reason?: string }
 * Simple confirmation modal — user reviews what will happen, clicks Pause or Cancel.
 */

import { PauseIcon } from '@heroicons/react/24/solid';
import { Button } from '@/components/ui/button';
import type { ToolConfirmationProps } from '../tool-registry';

export function PauseCampaignTool({ input, onConfirm, onReject }: ToolConfirmationProps) {
  const campaignName = (input.campaignName as string) || 'this campaign';
  const reason = input.reason as string | undefined;

  return (
    <div className="h-full flex items-center justify-center p-8">
      <div className="bg-card border border-border rounded-2xl p-8 max-w-md w-full shadow-lg">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-danger-surface flex items-center justify-center">
            <PauseIcon className="h-5 w-5 text-danger-foreground" />
          </div>
          <h2 className="text-lg font-semibold">Pause campaign?</h2>
        </div>

        <p className="text-sm text-muted-foreground mb-4">
          The agent wants to pause <span className="font-medium text-foreground">{campaignName}</span>.
          In-flight sends stop; scheduled future sends halt until the campaign is resumed.
        </p>

        {reason && (
          <div className="bg-surface-sunken border border-border rounded-lg p-3 mb-4 text-xs text-muted-foreground">
            <span className="font-medium text-foreground">Agent's reason:</span> {reason}
          </div>
        )}

        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onReject}>Cancel</Button>
          <Button variant="primary" onClick={() => onConfirm(input)}>
            <PauseIcon className="h-4 w-4" />
            Pause campaign
          </Button>
        </div>
      </div>
    </div>
  );
}
